import { Bar } from './Bar';
import { Circle } from './Circle';
import { Circles } from './Circles';
import { Multi } from './Multi';

const Progress = () => null;

Progress.Circle = Circle;
Progress.Circles = Circles;
Progress.Bar = Bar;
Progress.Multi = Multi;

export { Progress };
